export default {
  noopen: '求人の一般公開を停止しました。',
  preview: {
    dialogTitle: '求人プレビュー',
  },
  form: {
    title: {
      create: '求人作成',
      edit: '求人編集',
    },
    sections: {
      basicInfo: '募集要項',
      requirements: '応募要件',
      workSchedule: '労働条件',
      salaryBenefits: '給与・福利厚生',
      otherInfo: 'その他',
    },
    buttons: {
      save: '保存',
      publish: '公開',
      saveAndPublish: '保存して公開',
      cancel: 'キャンセル',
      goToInterviewProcess: '選考フロー管理',
      goToAffiliation: '所属先管理',
    },
    fieldFilters: {
      all: 'すべての項目',
      open: '一般公開項目',
      agent: 'エージェントのみ公開項目',
    },
    jobTitle: '求人名',
    positionType: '職種',
    enterprise: '募集企業',
    jobIndustry: '業界',
    headcount: '採用人数',
    recruitGraduateType: '採用対象',
    hasJobTransfer: '転勤',
    isUrgent: '急募',
    employmentForm: '雇用形態',
    hasEmploymentTerm: '雇用期間の定め',
    hasProbation: '試用期間',
    jobDescription: '業務内容',
    careerPath: 'キャリアパス',
    workplaceAtmosphere: '職場の雰囲気',
    workplaceAtmosphereAgentNote: '備考（エージェント向け）',
    agentOnly: 'エージェントのみ公開',
    recruitmentProcessId: '選考フロー',
    selectionProcessNote: '選考フローの説明',
    interviewMethod: '面接方法',
    expectedStartDate: '勤務開始時期',
    additionalNoteForAgent: '備考',
    japaneseLevelId: '日本語レベル',
    requirementNote: '必須条件',
    extraPointColumn: '歓迎要件',
    hasCertificationReq: '必須資格（語学以外）',
    requiredExperience: '求める経験／人物像',
    requiredExperienceAgentNote: '求める経験／人物像（エージェント向け）',
    overseasApplication: '海外からの応募',
    ageLimit: '年齢',
    ageLimitCondition: '年齢制限を適用されるための条件',
    nationalityLimit: '国籍・地域',
    nationalityLimitReason: '国籍・地域を適用するやむを得ない事情',
    otherRequirements: 'その他',
    otherNote: '備考（エージェント向け情報）',
    affiliationId: '所属先',
    affiliationNote: '所属先の補足説明',
    affiliationStructure: '所属先の人員構成',
    workAddress: '住所',
    nearestStation: '最寄り駅',
    workingHours: '就業時間',
    workingHoursNote: '就業時間の補足説明',
    stipulatedWorkTime: '所定労働時間',
    hasShifts: 'シフト勤務',
    hasFlextime: '変形労働制',
    overtimeHours: '想定残業時間',
    weeklyOffType: '週休',
    annualHolidays: '年間休日数',
    paidHolidaysRange: '年間有給休暇数',
    otherLeaves: 'その他の休暇',
    monthlyTotal: '月総支給額（税引き前）',
    payMode: '給与モデル',
    baseSalary: '基本給',
    baseSalaryNote: '月総支給額の説明',
    hasBonus: '賞与',
    hasTransportAllowance: '交通手当',
    hasOvertimePay: '残業手当',
    hasNightShiftAllowance: '夜勤手当',
    hasOverseasWorkerTravelExpenseSupport: '海外からの応募に伴う渡航費の支援',
    otherAllowances: 'その他の手当て',
    probationPay: '試用期間/研修期間の月総支給額（税引き前）',
    probationPayNote: '試用期間/研修期間の月総支給額の補足説明',
    hasSalaryIncrease: '昇給',
    socialInsuranceInfo: '社会保険',
    hasHousingSupport: '住宅サポート',
    hasVisaSupport: 'ビザに関するサポート',
    otherSupports: 'その他のサポート',
    remarks: 'その他説明',
    appDisplayImages: 'Linc APP にて公開する写真',
    appImagesSyncButton: '自動同期',
    appImagesUploadButton: 'アップロード',
    appImagesTip: '対応形式：jpg / jpeg / png \n 1ファイル10MB未満、最大6枚までアップロードできます。\n 所属先にてアップロード済みの画像は自動で同期されます。',
    appImagesMaxCountWarning: 'アップロードは最大{max}ファイルまでです',
    appImagesFormatError: '形式が正しくありません。jpg/jpeg/png形式のみ対応しています',
    appImagesSizeError: '1つのファイルは10MBまでです',
    appImagesSyncInfo: '同期機能は実装予定です',
    otherDocumentsTitle: 'その他資料',
    otherDocumentsUploadButton: 'アップロード',
    otherDocumentsTip: '対応形式：jpg / jpeg / png / doc / xlsx / xls / pdf \n 1ファイル10MB未満',
    otherDocumentsEmpty: 'アップロードされたファイルはありません',
    otherDocumentsFormatError: '形式が正しくありません。jpg/jpeg/png/doc/xlsx/xls/pdf形式のみ対応しています',
    otherDocumentsSizeError: '1つのファイルは10MBまでです',
    otherDocumentsMaxError: 'アップロードは最大{max}ファイルまでです',
    otherDocumentsExceedLimit: '選択したファイル数が多すぎます。最大{max}個まで、残り{remaining}個アップロードできます',
    options: {
      yes: 'はい',
      no: 'いいえ',
      has: 'あり',
      hasNot: 'なし',
      have: '有',
      noAsk: '不問',
      none: '無',
      can: '可',
      cannot: '不可',
      online: 'Web',
      offline: '対面',
      formalEmployee: '正社員',
      contractEmployee: '契約社員',
      partTimeEmployee: 'パート社員',
      fullWeekendOff: '完全週休二日制',
      weekendOff: '週休二日制',
      shiftSystem: 'シフト制',
      other: 'その他',
      hourPerDay: '時間/日',
      hourPerWeek: '時間/週',
      hourPerMonth: '時間/月',
      perHour: '時給',
      perDay: '日給',
      perMonth: '月給',
      perYear: '年俸',
      allowanceHealth: '健康保険',
      allowanceWelfare: '厚生年金保険',
      allowanceCompensation: '労災保険',
      allowanceEmployment: '雇用保険',
      publicOpened: '公開中',
      publicUnopened: '未公開',
      noOpenToAgent: '未共有',
      openedToAgent: '共有中',
      stopOpenedToAgent: '共有中止',
    },
    validation: {
      titleRequired: '求人名を入力してください',
      positionTypeRequired: '職種を選択してください',
      positionTypeInputRequired: '職種を入力してください',
      jobIndustryRequired: '業界を選択してください',
      headcountRequired: '採用人数を入力してください',
      headcountPositiveInteger: '正の整数を入力してください',
      recruitGraduateTypeRequired: '採用対象を選択してください',
      hasJobTransferRequired: '転勤を選択してください',
      hasJobTransferInput: '転勤を入力してください',
      hasEmploymentTermInput: '雇用期間の定めを入力してください',
      probationPayInput: '試用期間を入力してください',
      isUrgentRequired: '急募を選択してください',
      employmentFormRequired: '雇用形態を選択してください',
      jobDescriptionRequired: '業務内容を入力してください',
      careerPathRequired: 'キャリアパスを入力してください',
      recruitmentProcessIdRequired: '選考フローを選択してください',
      japaneseLevelIdRequired: '日本語レベルを選択してください',
      requirementNoteRequired: '必須条件を入力してください',
      hasCertificationReqRequired: '必須資格（語学以外）を選択してください',
      hasCertificationReqInput: '必須資格（語学以外）を入力してください',
      requiredExperienceRequired: '求める経験／人物像を入力してください',
      affiliationIdRequired: '所属先を選択してください',
      affiliationStructureRequired: '所属先の人員構成を入力してください',
      workAddressRequired: '住所を入力してください',
      workingHoursRequired: '就業時間を選択してください',
      hasShiftsRequired: 'シフト勤務を選択してください',
      hasShiftsInput: 'シフト勤務を入力してください',
      hasFlextimeRequired: '変形労働制を選択してください',
      hasFlextimeInput: '変形労働制を入力してください',
      overtimeHoursRequired: '想定残業時間を選択してください',
      overtimeHoursInput: '想定残業時間を入力してください',
      weeklyOffTypeRequired: '週休を選択してください',
      weeklyOffOtherNoteRequired: '週休その他を入力してください',
      monthlyTotalRequired: '月総支給額（税引き前）を選択してください',
      monthlyTotalRangeRequired: '月総支給額（税引き前）範囲を入力してください',
      monthlyTotalInputRequired: '月総支給額（税引き前）を入力してください',
      baseSalaryRequired: '基本給を選択してください',
      baseSalaryRangeRequired: '基本給範囲を入力してください',
      baseSalaryInputRequired: '基本給を入力してください',
      hasBonusRequired: '賞与を選択してください',
      hasBonusInput: '賞与を入力してください',
      hasTransportAllowanceRequired: '交通手当を選択してください',
      hasTransportAllowanceInput: '交通手当を入力してください',
      hasOvertimePayRequired: '残業手当を選択してください',
      hasOvertimePayInput: '残業手当を入力してください',
      hasNightShiftAllowanceRequired: '夜勤手当を選択してください',
      hasNightShiftAllowanceInput: '夜勤手当を入力してください',
      hasOverseasWorkerTravelExpenseSupportRequired: '海外からの応募に伴う渡航費の支援を選択してください',
      hasOverseasWorkerTravelExpenseSupportInput: '海外からの応募に伴う渡航費の支援を入力してください',
      hasSalaryIncreaseRequired: '昇給を選択してください',
      hasSalaryIncreaseInput: '昇給を入力してください',
      socialInsuranceInfoRequired: '社会保険を選択してください',
      hasHousingSupportRequired: '住宅サポートを選択してください',
      hasHousingSupportInput: '住宅サポートを入力してください',
      hasVisaSupportRequired: 'ビザに関するサポートを選択してください',
      hasVisaSupportInput: 'ビザに関するサポートを入力してください',
      probationPayRequired: '試用期間/研修期間の月総支給額（税引き前）を選択してください',
      probationPayRangeRequired: '試用期間/研修期間の月総支給額（税引き前）範囲を入力してください',
      probationPayInputRequired: '試用期間/研修期間の月総支給額（税引き前）を入力してください',
      endTimeMustBeAfterStartTime: '終了時間は開始時間より早く設定できません',
      overseasApplicationInput: '海外からの応募を入力してください',
      ageLimitInput: '年齢を入力してください',
      ageLimitConditionRequired: '年齢制限を適用されるための条件を選択してください',
      nationalityLimitInput: '国籍・地域を入力してください',
      nationalityLimitConditionRequired: '国籍・地域を適用するやむを得ない事情を選択してください',
      otherRequirementsRequired: '海外からの応募を選択してください',
      otherRequirementsInput: 'その他を入力してください',
      interviewMethodRequired: '面接方法を選択してください',
      interviewMethodInput: '面接方法を入力してください',
      hiddenFieldsErrorTitle: '一般公開項目の審査に通っていません',
      hiddenFieldsErrorContent: 'すべての項目表示に戻すと閲覧できます。',
      viewNow: '今すぐ見る'
    },
    placeholder: {
      pleaseEnter: '入力してください',
      pleaseSelect: '選択してください',
      workAddressNote: '所属先に紐づく住所が自動で反映されます',
      affiliationStructureNote: '所属先に紐づく人員構成が自動で反映されます',
      selectionProcessNote: '対象の選考フローに紐づく説明が自動で反映されます',
      monthlyTotal: '例：月給＝基本給＋残業手当＋住宅手当',
      payMode: '例：年収350万～500万＋決算賞与（年1回）',
      baseSalaryNote: '例：月給＝基本給＋残業手当＋住宅手当',
      workingHoursNote: '例：上記の時間の中でシフト勤務',
      hasTransportAllowance: '例：上限',
      otherAllowances: '例：食事手当',
      hasSalaryIncrease: '例：年1回：5000円/月',
      hasHousingSupport: '例：寮、借り上げ社宅、住宅手当',
      hasJobTransfer: '例：全国の店舗に転勤の可能性あり',
      hasAgeLimit: '18歳～40歳',
      hasNationalityLimit: 'ベトナムの方は登録支援機関業務の対応ができないため、受け入れが難しい',
      hasCertificationReq: '例：調理師免許、自動車免許 等',
      hasShifts: '例：10時~23時の間で8時間（店舗シフトによる）',
      hasFlextime: '例：1ヶ月単位。 1ヶ月を平均して週40時間以内',
      paidHolidaysRange: '例：入社後6か月で10日付与。以後、法定通り付与',
      hasBonus: '例：年1回（12月）に支給。昨年実績は基本給2か月分。',
      hasOvertimePay: '例：固定残業代あり（60,000円/30時間分） 超える分は、別途法定通り支給。',
      hasOverseasWorkerTravelExpenseSupport: '例：採用決定後、入社に伴う航空券代実費を支給（上限10万円）',
      hasVisaSupport: '例：申請書の作成、更新手続き等を支援',
      otherRequirements: '豚肉・牛肉の取り扱い有。アルコール消毒必須。'
    },
    messages: {
      loadDataFailed: 'データの読み込みに失敗しました',
      saving: '保存中...',
      saveSuccess: '保存に成功しました',
      saveFailed: '保存に失敗しました',
      publishing: '公開中...',
      publishSuccess: '公開に成功しました',
      publishFailed: '公開に失敗しました',
      saveAndPublishSuccess: '保存と公開に成功しました',
      saveAndPublishFailed: '保存と公開に失敗しました'
    }
  },
  breadcrumb: {
    jobManagement: '求人管理',
    jobDetail: '求人詳細'
  },
  status: {
    PUBLISHED: '公開中',
    WAIT_PUBLISH: '公開待ち',
    AUDIT_FAILED: '審査落ち',
    CLOSED: '公開停止'
  },
  detail: {
    positionType: '職種',
    status: '在留資格',
    employmentType: '雇用形態',
    location: '所属先',
    recruitCount: '採用人数',
    isUrgent: '急募',
    updatedAt: '更新日時',
    createdAt: '作成日時',
    creator: '作成者',
    openToAgent: 'エージェント共有',
    publicOpen: '一般公開',
    preview: 'プレビュー',
    downloadQrCode: 'ダウンロード',
    copyPublicPageUrl: '掲載ページURLをコピー',
    onlyPublishedJobCanOpen: '公開中の求人のみ一般公開が可能です。',
    tabs: {
      jobInfo: '求人情報',
      candidates: '候補者一覧',
      changeLog: '変更履歴'
    },
  },
  candidateList: {
    totalCount: '共計',
    items: '件',
    allStatus: 'すべて',
    candidateColumn: '候補者',
    candidateStatus: '選考ステータス',
    progressColumn: '選考進度',
    channelColumn: '応募チャンネル',
    applyTimeColumn: '応募日時',
    actionColumn: '操作',
    viewDetail: '選考詳細',
    resumeScreening: '履歴書選考',
    interview1: '一次面接',
    interview1Pending: '一次面接予約待ち',
    interview1Waiting: '一次面接承諾待ち',
    interview1Scheduled: '一次面接待ち',
    interview2: '二次面接',
    interview2Pending: '二次面接予約待ち',
    interview2Waiting: '二次面接承諾待ち',
    interview2Scheduled: '二次面接待ち',
    offer: '内定',
    offerMade: '内定',
    onboarding: '入社',
    onboardingConfirmed: '入職確定',
    onboardingPending: '入職待ち',
    onboarded: '入職済み',
    appChannel: 'APP応募',
    selfRegister: '自社登録',
    noApplicationData: 'データなし',
    isStop: 'すでに終了',
  },
  changeLog: {
    changeTime: '変更日時',
    changer: '変更者',
    changeType: '変更種類',
    fieldName: '変更項目名',
    oldValue: '変更前',
    newValue: '変更後',
    edit: '編集',
    create: '新規作成',
    publish: '公開'
  },
  createDialog: {
    title: '求人作成',
    residenceTypeLabel: '在留資格',
    specificSkill: '特定技能',
    technicalHumanities: '技人国',
    activitiesOutsideStatus: '資格外活動',
    cancel: 'キャンセル',
    create: '作成',
    validation: {
      residenceTypeRequired: '在留資格を選択してください'
    },
    createSuccess: '作成成功',
    createFailed: '作成失敗'
  },
  list: {
    title: '求人管理',
    filters: {
      jobId: '求人ID',
      jobIdPlaceholder: '選択してください',
      positionType: '職種',
      positionTypePlaceholder: '選択してください',
      residenceStatus: '在留資格',
      residenceStatusPlaceholder: '選択してください',
      employmentForm: '雇用形態',
      employmentFormPlaceholder: '選択してください',
      affiliation: '所属先',
      affiliationPlaceholder: '選択してください',
      jobTitle: '求人名',
      jobTitlePlaceholder: '入力してください',
      createDate: '作成日',
      openDate: '求人共有日',
      creator: '作成者',
      creatorPlaceholder: '選択してください',
      openToAgent: 'エージェント共有',
      publicOpen: '一般公開',
      moreFilters: '詳細検索'
    },
    searchButton: '検索',
    resetButton: 'リセット',
    createButton: '求人作成',
    batchOperations: {
      button: '一括操作',
      close: '一括停止',
      openToAgent: '一括エージェント共有',
      publicOpen: '一括一般公開',
      publicClose: '一括一般非公開',
      publicOpenBtn: '一般公開',
      publicCloseBtn: '一般非公開',
      closeConfirmTitle: '一括停止',
      closeConfirmContent: '選択した {count} 件の求人を停止してよろしいですか？',
      closeWithSelectingTitle: '一括停止',
      closeWithSelectingContent: '選択した #total# 件の求人のうち、#count# 件には現在進行中の選考があります。\n 停止すると選考プロセスは自動的に終了します。これらの求人を一括停止しますか？',
      closeWithoutSelectingTitle: '一括停止',
      closeWithoutSelectingContent: '選択した #count# 件の求人を一括停止しますか？',
      viewSelectingJobs: '選考中の求人を確認',
      publicOpenTitle: '一括一般公開',
      publicOpenContent: '選択した #count# 件の求人を一括一般公開しますか？',
      publicCloseTitle: '一括一般非公開',
      publicCloseContent: '選択した #count# 件の求人を一括一般非公開しますか？',
      selectFirst: '操作する求人を選択してください',
      closeSuccess: '一括停止に成功しました',
      closeFailed: '一括停止に失敗しました',
      openToAgentSuccess: '一括エージェント共有に成功しました',
      openToAgentFailed: '一括エージェント共有に失敗しました',
      publicOpenSuccess: '一括一般公開に成功しました',
      publicOpenFailed: '一括一般公開に失敗しました',
      publicCloseSuccess: '一括一般非公開に成功しました',
      publicCloseFailed: '一括一般非公開に失敗しました'
    },
    tabs: {
      published: '公開中',
      unpublished: '公開待ち',
      rejected: '審査落ち',
      closed: '公開停止'
    },
    tableStats: '選択 #selected# 件',
    tableStats2: '合計：#total# 件',
    columns: {
      jobId: '求人 ID',
      positionType: '職種',
      residenceStatus: '在留資格',
      employmentForm: '雇用形態',
      affiliation: '所属先',
      jobTitle: '求人',
      recruitCount: '採用人数',
      applicantCount: '応募人数',
      hiredCount: '入社人数',
      openToAgent: 'エージェント共有',
      notOpen: '未共有',
      opened: '共有中',
      openedAgent: '共有中エージェント',
      stopped: '停止開放',
      stoppedAgent: '共有中止エージェント',
      publicStatus: '一般公開',
      publishTime: '公開日時',
      publishTimeTooltip: '求人作成後、作成／編集画面で公開した日時',
      updateTime: '更新日時',
      auditTime: '審査日時',
      closeTime: '停止日時',
      createTime: '作成日時',
      creator: '作成者',
      rejectionReason: '審査不通過の理由',
      operations: '操作',
      publicStatusOpen: '公開中',
      publicStatusClose: '未公開'
    },
    operations: {
      detail: '詳細',
      edit: '編集',
      copy: 'コピー',
      close: '停止',
      publish: '公開',
      delete: '削除',
      openToAgent: 'エージェント共有'
    },
    emptyStates: {
      noConditions: {
        title: 'データなし',
        description: 'まだ職位が作成されていません'
      },
      noResults: {
        title: '検索結果はありません',
        description: '検索条件を変更して再検索してください'
      }
    },
    deleteDialog: {
      confirmTitle: '求人削除',
      confirmContent: '削除すると元に戻せません。\n 求人「{jobId}」を削除してよろしいですか？',
      notAllowedTitle: '削除できません',
      notAllowedContent: '求人「{jobId}」には選考中のデータがあるため、進行中の選考結果を確認してください。'
    },
    closeDialog: {
      confirmTitle: '求人停止',
      confirmContent: '停止すると、この求人に応募できなくなります。\n 求人「{jobId}」を停止してよろしいですか？',
      warningContent: 'こちらの求人には、進行中の選考があります。\n停止すると、選考プロセスは強制的に中止されます。\n求人「{jobId}」を停止してよろしいですか？',
      withInterviewStatContent: '#selectedCount#件の求人を選択しています。そのうち#jobCount#件には、内定に至っていない選考が合計#totalCount#件あります。停止すると、これらの選考は強制的に終了します。これらの求人を一括停止しますか？',
      singleWithInterviewStatContent: '求人「#jobId#」には、内定に至っていない選考が#totalCount#件あります。停止すると、これらの選考は強制的に終了します。求人を停止しますか？',
      tableHeaders: {
        job: '求人',
        resumeScreening: '書類選考',
        interview: '面接'
      }
    },
    publishDialog: {
      confirmTitle: '求人公開',
      confirmContent: '求人「{jobId}」を公開してよろしいですか？',
      incompleteTitle: '求人公開',
      incompleteContent: '必須項目が未入力です。入力を完了させると公開できます。',
      goComplete: '入力へ'
    },
    publicDialog: {
      openTitle: '一般公開',
      openContent: '求人「{jobId}」を一般公開しますか？',
      openButton: '一般公開',
      closeTitle: '一般非公開',
      closeContent: '求人「{jobId}」を一般非公開にしますか？',
      closeButton: '一般非公開'
    }
  },
  dialog: {
    openToAgent: {
      title: 'エージェント共有',
      description: '求人「{jobId}」は以下のエージェントに共有されます：',
      label: 'エージェント',
      selectAgentRequired: 'エージェントを選択してください',
      selectJobRequired: 'エージェントを選択してください',
      success: 'エージェント共有しました',
      failed: 'エージェント共有できませんでした',
      confirmRemoveTitle: '共有解除確認',
      confirmRemoveContent: '以下の #count# 社のエージェントには、内定に至っていない選考が残っています。求人の共有を停止すると、これらの選考プロセスは強制的に終了します。これらのエージェントに対して求人「#totalCount#」の共有を停止しますか？',
      tableHeaders: {
        agent: 'エージェント',
        resumeScreening: '書類選考',
        interview: '面接'
      }
    },
    batchOpenToAgent: {
      title: '一括エージェント共有',
      description: '選択した #count# 件の求人を以下のエージェントに共有します：',
      label: 'エージェント',
      selectAgentRequired: 'エージェントを選択してください',
      selectJobRequired: 'エージェントを選択してください',
      success: '一括エージェント共有しました',
      failed: '一括エージェント共有できませんでした'
    }
  },
  agentManage: {
    title: 'エージェント管理',
    filters: {
      company: 'エージェント',
      companyPlaceholder: '選択してください',
      contact: '担当者',
      contactPlaceholder: '選択してください',
      email: '担当者メール',
      emailPlaceholder: '選択してください',
      tag: 'タグ',
      tagPlaceholder: '選択してください'
    },
    searchButton: '検索',
    resetButton: 'リセット',
    columns: {
      company: 'エージェント',
      address: '会社住所',
      contact: '担当者',
      email: '担当者メール',
      remark: '備考',
      tags: 'タグ',
      updatedBy: '更新者',
      updatedAt: '更新日時',
      operations: '操作'
    },
    operations: {
      edit: '編集'
    },
    emptyStates: {
      noConditions: {
        title: 'データなし'
      },
      noResults: {
        title: '検索結果なし',
        description: '検索条件を変更してもう一度お試しください'
      }
    },
    editDialog: {
      title: 'エージェント情報編集',
      contact: '担当者',
      contactPlaceholder: '入力してください',
      email: '担当者メール',
      emailPlaceholder: '入力してください',
      remark: '備考',
      remarkPlaceholder: '入力してください',
      tags: 'タグ',
      tagsPlaceholder: '入力してください',
      addTag: '追加',
      cancel: 'キャンセル',
      save: '保存',
      validation: {
        contactRequired: '担当者を入力してください',
        emailRequired: '担当者メールを入力してください',
        emailFormat: '担当者メールアドレスの形式が正しくありません'
      }
    },
    tableStats: '合計：#total# 件'
  },
  agentList: {
    title: '求人管理',
    filters: {
      enterprise: '募集企業',
      enterprisePlaceholder: '選択してください'
    },
    tableStats: '合計：#total# 件',
    columns: {
      jobId: '求人 ID',
      enterprise: '募集企業',
      jobTitle: '求人名',
      positionType: '職種',
      residenceStatus: '在留資格',
      employmentForm: '雇用形態',
      affiliation: '所属先',
      recruitCount: '採用人数',
      recommendCount: '推薦人数',
      entryCount: '入社人数',
      outOpen: '一般公開',
      openTime: '求人共有日時',
      updateTime: '更新日時',
      createTime: '作成日時',
      creator: '作成者'
    }
  },
  businessManage: {
    title: '募集企業',
    filters: {
      company: '募集企業',
      companyPlaceholder: '選択してください',
      contact: '担当者',
      contactPlaceholder: '選択してください',
      email: '担当者メール',
      emailPlaceholder: '選択してください',
      tag: 'タグ',
      tagPlaceholder: '選択してください'
    },
    searchButton: '検索',
    resetButton: 'リセット',
    columns: {
      company: '募集企業',
      address: '会社住所',
      affiliation: '所属先数',
      contact: '担当者',
      email: '担当者メール',
      remark: '備考',
      tags: 'タグ',
      updatedBy: '更新者',
      updatedAt: '更新日時',
      operations: '操作'
    },
    operations: {
      detail: '詳細',
      addTag: 'タグ追加'
    },
    remarkDialog: {
      title: '備考',
      remarkLabel: '備考',
      remarkPlaceholder: '入力してください',
      cancel: 'キャンセル',
      save: '保存'
    },
    tagDialog: {
      title: 'タグ追加',
      tagLabel: 'タグ',
      addButton: '追加',
      cancel: 'キャンセル',
      save: '保存'
    },
    detailDrawer: {
      title: '企業情報',
      tabs: {
        basicInfo: '基本情報',
        supportOrg: '登録支援機構',
        responsiblePerson: '担当者情報'
      },
      basicInfo: {
        legalPerson: '法人',
        corporateNumber: '法人番号（13桁）',
        companyType: '会社の種類',
        registrationDate: '設立日',
        capital: '会社の資本金（円）',
        companySize: '会社規模',
        foreignEmployeeScale: '外国人従業員数',
        revenueScale: '営業利益(円/年)',
        websiteUrl: '会社ホームページ',
        address: '会社住所',
        companyIntroduction: '会社紹介',
      },
      supportOrg: {
        legalPerson: '法人',
        corporateNumber: '法人番号（13桁）',
        companyType: '会社類型',
        supportMethod: '登録支援方式',
        delegationMethod: '委託方法',
        remarks: '備考欄'
      },
      responsiblePerson: {
        name: '氏名',
        position: '役職',
        phone: '電話番号／携帯番号',
        email: 'メールアドレス'
      }
    },
    tableStats: '合計：#total# 件'
  }
};
